import { ScrollArea } from '@mantine/core';
import {
	IconAddressBook,
	IconBriefcase,
	IconBuildingHospital,
	IconCalculator,
	IconCashRegister,
	IconContract,
	IconDashboard,
	IconDeviceTv,
	IconReportAnalytics,
	IconSettings,
	IconTruckDelivery,
	IconUsersGroup,
} from '@tabler/icons-react';
import { NavLink } from '../../components/NavLink';
import { ADMIN, BRISTEC_ADMIN, MODERATOR } from '../../const/constants';
import { useAuth } from '../../hooks/useAuth';
import { useOrganisation } from '../../hooks/useOrganisation';

export function SidebarPaths() {
	const organisation = useOrganisation();
	const auth = useAuth();

	const iconProps = {
		size: '1.25rem',
		stroke: 1.5,
	};

	return (
		<ScrollArea>
			<NavLink
				href={`/${organisation.get()}/dash`}
				label={'Dashboard'}
				icon={<IconDashboard {...iconProps} />}
			/>
			<NavLink
				href="#"
				label={'Sales'}
				icon={<IconReportAnalytics {...iconProps} />}
			>
				<NavLink
					href={`/${organisation.get()}/sales/sales-viewer`}
					label={'Live Sales'}
				/>
				<NavLink
					href={`/${organisation.get()}/sales/tenders`}
					label={'Tenders'}
				/>
				<NavLink
					href={`/${organisation.get()}/sales/product-totals`}
					label={'Product Totals'}
				/>
				<NavLink
					href={`/${organisation.get()}/sales/group-totals`}
					label={'Group Totals'}
				/>
				<NavLink
					href={`/${organisation.get()}/sales/pharmacy-first`}
					label={'Pharmacy First'}
				/>
			</NavLink>
			<NavLink
				href="#required-for-focus"
				label={'Stock'}
				icon={<IconCalculator {...iconProps} />}
			>
				<NavLink
					href={`/${organisation.get()}/stock/products`}
					label={'Products'}
				/>
				<NavLink
					href={`/${organisation.get()}/stock/price-change`}
					label={'Prices'}
				/>
				<NavLink
					href={`/${organisation.get()}/stock/product-cost`}
					label={'Product Cost'}
				/>
				<NavLink
					href={`/${organisation.get()}/stock/product-log`}
					label={'Product Logs'}
				/>
			</NavLink>
			<NavLink
				href={`/${organisation.get()}/orders`}
				label={'Orders'}
				icon={<IconTruckDelivery {...iconProps} />}
			/>
			<NavLink
				href="#required-for-focus"
				label={'Maintenance'}
				icon={<IconSettings {...iconProps} />}
			>
				<NavLink
					href={`/${organisation.get()}/maintenance/branches`}
					label={'Branches'}
				/>
				<NavLink
					href={`/${organisation.get()}/maintenance/suppliers`}
					label={'Suppliers'}
				/>
				<NavLink
					href={`/${organisation.get()}/maintenance/groups`}
					label={'Groups'}
				/>
				<NavLink
					href={`/${organisation.get()}/maintenance/departments`}
					label={'Departments'}
				/>
				<NavLink
					href={`/${organisation.get()}/maintenance/promotions`}
					label={'Promotions'}
				/>
				<NavLink
					href={`/${organisation.get()}/maintenance/pos-messages`}
					label={'POS Messages'}
				/>
				<NavLink href="#required-for-focus" label={'VAT'}>
					<NavLink
						href={`/${organisation.get()}/maintenance/vat-reports`}
						label={'VAT Reports'}
					/>
					<NavLink
						href={`/${organisation.get()}/maintenance/vat-rates`}
						label={'VAT Rates'}
					/>
					<NavLink
						href={`/${organisation.get()}/maintenance/eod-vat`}
						label={'EOD VAT'}
					/>
				</NavLink>
			</NavLink>
			<NavLink
				href="#required-for-focus"
				label={'EPOS'}
				icon={<IconCashRegister {...iconProps} />}
			>
				<NavLink
					href={`/${organisation.get()}/epos/banking`}
					label={'Banking'}
				/>
				<NavLink
					href={`/${organisation.get()}/epos/banking-totals`}
					label={'Banking Totals'}
				/>
				<NavLink
					href={`/${organisation.get()}/epos/eod-logs`}
					label={'End of Day Logs'}
				/>
				<NavLink
					href={`/${organisation.get()}/epos/voids`}
					label={'Voids and No Sales'}
				/>
				<NavLink
					href={`/${organisation.get()}/epos/missed-items`}
					label={'Missed Items'}
				/>
				<NavLink
					href={`/${organisation.get()}/epos/paid-in-out`}
					label={'Paid In/Out'}
				/>
				<NavLink
					href={`/${organisation.get()}/epos/weekly-targets`}
					label={'Weekly Targets'}
				/>
				<NavLink
					href={`/${organisation.get()}/epos/cash-declarations`}
					label={'Cash Declarations'}
				/>
			</NavLink>
			<NavLink
				href="#required-for-focus"
				label={'Pharmacy'}
				icon={<IconBuildingHospital {...iconProps} />}
			>
				<NavLink
					href={`/${organisation.get()}/pharmacy/rx-counts`}
					label={'RX Counts'}
				/>
				<NavLink
					href={`/${organisation.get()}/pharmacy/near-misses`}
					label={'Near Misses'}
				/>
				<NavLink
					href={`/${organisation.get()}/pharmacy/prescriptions`}
					label={'Prescriptions'}
				/>
			</NavLink>
			<NavLink
				href={`/${organisation.get()}/rear-display`}
				label={'Rear Display'}
				icon={<IconDeviceTv {...iconProps} />}
			/>
			<NavLink
				label={'Customers'}
				href={`/${organisation.get()}/customer/list`}
				icon={<IconUsersGroup {...iconProps} />}
			/>
			<NavLink
				label={'Staff'}
				href="#required-for-focus"
				icon={<IconBriefcase {...iconProps} />}
			>
				<NavLink
					label={'Staff List'}
					href={`/${organisation.get()}/staff/list`}
				/>
				<NavLink
					label={'Attendance'}
					href={`/${organisation.get()}/staff/attendance`}
				/>
			</NavLink>

			{[MODERATOR, ADMIN, BRISTEC_ADMIN].includes(auth.getRole()) && (
				<NavLink
					label={'Accounts'}
					href={`/${organisation.get()}/accounts`}
					icon={<IconAddressBook {...iconProps} />}
				/>
			)}
			{[BRISTEC_ADMIN].includes(auth.getRole()) && (
				<NavLink
					href="/admin"
					label={'Bristec Administration'}
					icon={<IconContract {...iconProps} />}
				/>
			)}
		</ScrollArea>
	);
}
